<div class="bg-[#FFFFFF] border border-[#E5E8EC] mb-4 lg:block rounded-[16px]">
    <div class="text-sm mt-2 ml-4 animate-pulse">
        <div class="py-3">
            <div class="h-5 bg-gray-200 rounded w-28"></div>
        </div>
        <div *ngIf="showSearch" class="mr-4 mb-4">
            <div class="h-9 bg-gray-200 rounded w-full"></div>
        </div>
        <ul class="space-y-4 pb-4">
            <li
                *ngFor="let item of [].constructor(itemCount); let i = index"
                class="flex items-center justify-between mr-4"
            >
                <div class="flex items-center">
                    <div class="h-4 w-4 bg-gray-200 rounded"></div>
                    <div
                        class="ml-3 h-4 bg-gray-200 rounded"
                        [ngStyle]="{ width: 40 + (i % 3) * 16 + 'px' }"
                    ></div>
                </div>
                <div
                    *ngIf="showCount"
                    class="h-8 bg-gray-200 rounded w-16"
                ></div>
            </li>
        </ul>
        <div *ngIf="showSearch" class="pb-4">
            <div class="h-4 bg-gray-200 rounded w-20"></div>
        </div>
    </div>
</div>

